import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject, debounceTime, Observable, Observer } from "rxjs";
import { TaskService } from "../../services/task.service";
import { AuthService } from "../../auth.service";
import { Router } from "@angular/router";
import { Messages } from "../../model/messages";
import { Task } from "../../model/task";
import { Navigation } from "../../model/navigation";
import { Ticket } from "../../model/ticket";
import { FormGroup } from "@angular/forms";
import { TicketService } from "../../services/ticket.service";
import { SingleChoice } from "../../model/singlechoice";
import { UsersService } from "../../services/users.service";
import { StatusService } from "../../services/status.service";
import { DependentChoice } from "../../model/dependentchoice";
import { NavigationHelper } from "../../services/navigation.helper";

@Component({
  selector: "task",

  templateUrl: "task.component.html",
  styleUrls: ["task.component.css"],
})
export class TaskComponent implements OnInit {
  @Output() taskSelected = new EventEmitter<number>();
  @Input() isMobile: boolean = false;
  @Output() choiceEvent: EventEmitter<SingleChoice> = new EventEmitter();
  @Input() currentTicket: Observable<Ticket>;
  taskForm: FormGroup;
  messages: BehaviorSubject<Messages>;
  tasks: BehaviorSubject<Task[]>;
  task = new BehaviorSubject<Task>(
    new Task(0, 0, "", "", 0, 0, new Date(), "", "", 0)
  );

  selectedTask: Task | null = null;
  title: BehaviorSubject<string> = new BehaviorSubject<string>("");
  currentId: number | null;
  showCreateForm: boolean = false;
  editMode: boolean = false;
  constructor(
    private taskService: TaskService,
    private authService: AuthService,
    private router: Router,
    private ticketService: TicketService,
    private users: UsersService,
    private statuses: StatusService,
    private nav: NavigationHelper
  ) {
    this.messages = new BehaviorSubject(Messages.EMPTY);
    this.tasks = new BehaviorSubject<Task[]>([]);
  }

  ngOnInit(): void {
    this.title.next("tasks.title");
    const token = this.authService.token;
    if (this.currentTicket) {
      this.currentTicket.subscribe((ticket) => {
        this.currentId = ticket.id;

        if (this.currentId && this.currentId > 0) {
          const task = ticket.parts?.tasks;

          this.taskService.accept(task);
          this.taskService.select(Task.EMPTY);
        }
      });
      this.taskService.tasksObservable.subscribe((task) => {
        this.tasks.next(task);
      });
    }
    this.nav.fragmentId.subscribe((id) => {
      const fragmentId = Number(id);

      if (
        this.nav.currentFragmentTopic === "task" &&
        (id === "-9" || Number(id) > 0)
      ) {
        this.showCreateForm = true;
        this.editMode = true;
        const newTask = new Task(-9, 0, "", "", 0, 0, new Date(), "", "", 0);

        this.selectedTask = newTask;
        this.taskService.select(newTask);
      }
      if (fragmentId > 0) {
        const found = this.tasks.value.find((t) => t.id === fragmentId);

        if (found) {
          this.selectedTask = found;
          this.taskService.select(found);

          const action = this.nav.currentAction;

          if (action === "fragment") {
          } else if (action === "fragmentedit") {
            this.editMode = true;
          }
        }
      }
    });
  }
  selectTask(task: Task): void {
    this.showCreateForm = false;
    this.selectedTask = task;
    this.taskService.select(task);

    const taskId: number = task.id;
    const url = "tickets/" + this.currentId + "/fragment/task/" + taskId;
    if (taskId) {
      this.router.navigate([url]).then(() => {
        this.taskSelected.emit(taskId);
      });
    }
    this.showCreateForm = false;
  }

  createTask(): void {
    this.selectedTask = null;
    this.showCreateForm = true;
    const newTask = new Task(
      Navigation.NEW,
      0,
      "",
      "",
      0,
      0,
      new Date(),
      "",
      "",
      0
    );
    this.taskService.selectedTask.next(newTask);
    const url =
      "tickets/" + this.currentId + "/fragmentedit/task/" + Navigation.NEW;
    this.router.navigate([url]).then(() => {
      this.taskSelected.emit(Navigation.NEW);
    });
  }
}
